export * from './MarcaServiceAdapter'
